export default "__VITE_ASSET__Bizvat84__"